/* eslint-disable max-len */
// src/services/inventoryService.js
import { mockProducts } from '../data/salesData';

// Simulate a database of inventory items
let inventory = [...mockProducts];

const getInventory = () => [...inventory];

const getProductById = (productId) => inventory.find((product) => product.id === productId);

const updateStock = (productId, quantityChange) => {
  const productIndex = inventory.findIndex((p) => p.id === productId);
  if (productIndex === -1) {
    throw new Error(`Product with ID ${productId} not found`);
  }

  const updatedProduct = {
    ...inventory[productIndex],
    stock: Math.max(0, inventory[productIndex].stock + quantityChange),
  };

  inventory = [
    ...inventory.slice(0, productIndex),
    updatedProduct,
    ...inventory.slice(productIndex + 1),
  ];

  return updatedProduct;
};

const getLowStockItems = (threshold = 5) => inventory.filter((product) => product.stock <= threshold);

export {
  getInventory,
  getProductById,
  updateStock,
  getLowStockItems,
};
